import { Box, IconButton, Stack, Tooltip, CircularProgress } from "@mui/material";
import { Add, Remove, RestartAlt } from "@mui/icons-material";
import { useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./InvoicePreview.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function InvoicePreview({ url, type, scale: initialScale, maxHeight = "1100px" }) {
  const [numPages, setNumPages] = useState();
  const [scale, setScale] = useState(initialScale || 1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleZoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.25, 3));
  };

  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.25, 0.5));
  };

  const handleResetZoom = () => {
    setScale(initialScale || 1);
  };

  return (
    <Box position="relative">
      <Stack
        direction="row"
        spacing={1}
        sx={{
          mb: 1,
          p: 1,
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 10,
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
          borderRadius: "8px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Tooltip title="Zoom Out">
          <IconButton
            onClick={handleZoomOut}
            disabled={scale <= 0.5}
            size="small"
            sx={{
              border: "1px solid #ddd",
              borderRadius: "4px",
            }}
          >
            <Remove fontSize="small" />
          </IconButton>
        </Tooltip>
        <Box sx={{ minWidth: "60px", textAlign: "center", fontSize: "14px", fontWeight: "500" }}>
          {Math.round(scale * 100)}%
        </Box>
        <Tooltip title="Zoom In">
          <IconButton
            onClick={handleZoomIn}
            disabled={scale >= 3}
            size="small"
            sx={{
              border: "1px solid #ddd",
              borderRadius: "4px",
            }}
          >
            <Add fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Reset Zoom">
          <IconButton
            onClick={handleResetZoom}
            size="small"
            sx={{
              border: "1px solid #ddd",
              borderRadius: "4px",
            }}
          >
            <RestartAlt fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
      <Box
        borderRadius={"8px"}
        sx={{
          maxHeight,
          backgroundColor: "#F2F2F2",
          overflowX: "auto",
          overflowY: "auto",
          textAlign: "center"
        }}
      >
        {type === "pdf" ? (
          <div style={{ display: "inline-block" }}>
            <Document 
              file={url} 
              onLoadSuccess={onDocumentLoadSuccess} 
              loading={
                <Box display="flex" justifyContent="center" alignItems="center" padding={16}>
                  <CircularProgress />
                </Box>
              }
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  scale={scale || 1}
                  loading="lazy"
                  renderTextLayer={true}
                  renderAnnotationLayer={true}
                />
              ))}
            </Document>
          </div>
        ) : (
          <div style={{ display: "inline-block", width: "100%" }}>
            <img
              src={url}
              className={"docContainer"}
              style={{
                width: `${scale * 100}%`,
                maxWidth: "none",
                transition: "width 0.2s ease-in-out",
                display: "block"
              }}
              alt="Invoice preview"
              loading="lazy"
            />
          </div>
        )}
      </Box>
    </Box>
  );
}
